<template>
  <div class="home">
    <div class="homeLeft">
      <el-scrollbar>
        <sidebar :isCollapse="isCollapse" />
      </el-scrollbar>
      <div class="collapse">
        <i @click="handleCollapse"  class="iconfont" :class="isCollapse?'iconzhankai':'iconshouqi'"></i>
      </div>
    </div>

    <el-main class="homePages" :class="isCollapse?'homePages-mini':''">
      <div class="navTab">
        <div class="nav-left">
          <tagbar :isCollapse="isCollapse" />
        </div>
        <div class="nav-right">
          <topbar />
        </div>
      </div>
      <div class="content" :class="{'no-bg': isNoBg}">
        <keep-alive :include="cachedViews">
          <router-view :key="$route.fullPath" />
        </keep-alive>
      </div>
    </el-main>
  </div>
</template>

<script>
import Sidebar from './SideBar'
import Tagbar from './TagBar'
import Topbar from './TopBar'
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
import { cacheHelper } from '@utils/cacheHelper'

export default {
  name: 'Layout',
  components: {
    Sidebar,
    Topbar,
    Tagbar,
  },
  data() {
    return {
      isCollapse: false,
      calcHeight: 112,
      restHeight: 0,
      clientHeight: 1080,
    }
  },
  computed: {
    ...mapGetters({
      tableHeight: 'tableHeight',
      cachedViews: 'cachedViews',
    }),
    isNoBg() {
      const routeName = this.$route.name
      return routeName === 'addWaybill' || routeName === 'problemParcelDispose' || routeName === 'problemParcelDisposeDetail'
    },
  },
  watch: {
    $route(to, from) {
      this.$nextTick(() => {
        this.calcTableHeight()
      })
    },
  },
  created() {
  },
  mounted() {
    this.$nextTick(() => {
      this.calcTableHeight()
      const ctx = this
      // 绑定窗口resize事件
      window.addEventListener('resize',
        debounce(() => {
          ctx.calcTableHeight()
        }, 200))
    })
    cacheHelper.getUsage()
    this.$bus.$on('doLayout', () => {
      this.$nextTick(() => this.calcTableHeight())
    })
  },
  methods: {
    ...mapActions(['SET_COLLAPSE', 'SET_TABLE_HEIGHT']),
    // 表格高度计算防抖
    debounceCalc() {
      debounce(() => {
        this.calcTableHeight()
      }, 200)
    },
    handleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    // 计算元素的高度用于表格自适应
    getRestHeight() {
      const arr = ['Title', 'Search', 'Pagination', 'Menu', 'Tip']
      let height = 0
      arr.forEach(function(id) {
        const el = document.getElementById('jms' + id)
        if (el && el.clientHeight) {
          console.log('jms' + id + ':', el.clientHeight)
          height += el.clientHeight
        }
      })
      return height
    },
    calcTableHeight() {
      this.clientHeight = document.documentElement.clientHeight
      this.restHeight = this.getRestHeight()
      const tableHeight = this.clientHeight - this.restHeight - this.calcHeight
      this.SET_TABLE_HEIGHT(tableHeight)
    },
  },
  beforeRouteLeave (to, from, next) {
    this.$bus.$off('doLayout')
    next()
  },
  destroyed() {
    // 清除定时任务/绑定事件/eventBus事件
    window.removeEventListener('resize', this.debounceCalc, false)
    this.$bus.$off('doLayout')
  },
}
</script>
<style lang="scss" scope rel="text/css">
.navTab{
  height: 48px;
  width: 100%;
  display: flex;
  .nav-left{
    flex:1;
    width: 300px;
  }
  .nav-right{
    max-width: 600px;
  }
}
.no-bg {
  background: none;
}

</style>
